/* eslint-disable import/prefer-default-export */
import { useSelector } from 'react-redux'
import { AppState } from 'state'

export const usePrices = () => useSelector((state: AppState) => state.prices.data)
